// extracted by mini-css-extract-plugin
export default {"card":"nia-z","carouselContainer":"oia-z","carouselContent":"pia-z"};